import { FC } from "react";
import { AppearedContent } from "./AppearedContent";

type LoadedContentProps = {
  isLoading: boolean;
  content: any;
};

export const LoadedContent: FC<LoadedContentProps> = ({
  isLoading,
  content,
}) =>
  isLoading ? (
    <AppearedContent
      isLoaded={false}
      skeletonOptions={{
        amount: 1,
        skeletonStyle: "iconStyle",
      }}
    />
  ) : (
    content
  );
